import { memo } from 'react'
import { useSelector } from 'react-redux'
import PayoffGraphMetaDataDisplay from '../payoffGraph/PayoffGraphMetaDataDisplay'
import { PAYOFF_CHART_META_KEY } from '../payoffGraph/payoffGraphMetaDataStore'
import { selectPayoffPreferences } from '../../selectors/user'

const PayoffMetaDataDisplay = () => {
    const { showOiBars = true } = useSelector(selectPayoffPreferences)
    return <PayoffGraphMetaDataDisplay metaDataKey={PAYOFF_CHART_META_KEY} showOiBars={showOiBars} />
}

export default memo(PayoffMetaDataDisplay)
